import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";

function ContractTitle() {
  const { t } = useTranslation();
  const { contract } = useSelector((state) => state.b2bContractsReducer);

  return (
    contract.code &&
    contract.economicGroup && (
      <h3>
        {t("CONTRACT")} #{contract.code} • {decryptIfEncrypted(contract.economicGroup.name)}
      </h3>
    )
  );
}

export default ContractTitle;
